import React from 'react';
import { FeatureAdminPanel } from './FeatureAdminPanel';
import './Admin.css';

/**
 * Modal wrapper around FeatureAdminPanel.
 * Props:
 *   tenant  — { id, name } object for the tenant being configured
 *   onClose — called when the modal should close
 */
export function TenantFeatureManagement({ tenant, onClose }) {
  if (!tenant) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal-content"
        style={{ maxWidth: '700px' }}
        onClick={e => e.stopPropagation()}
      >
        <div className="modal-header">
          <h2 className="modal-title">{tenant.name} — Feature Flags</h2>
          <button className="modal-close" onClick={onClose} aria-label="Close">✕</button>
        </div>

        <FeatureAdminPanel tenantId={tenant.id} />

        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
}
